// The support form (go live, S1–S3): what people write to Hearth about, kept in the Support table
// and emailed to the operator.

// Feedback first: the form's default (owner, 2026-11-04, for the beta). Tickets from before keep their old
// categories (help, billing, broken, idea, complaint, privacy, abuse); nothing reads them back.
export const SUPPORT_CATEGORIES = ['feedback', 'billing', 'help', 'abuse'] as const;
export type SupportCategory = (typeof SUPPORT_CATEGORIES)[number];

/** How the form names each (owner, 2026-11-04). */
export const SUPPORT_CATEGORY_NAMES: Readonly<Record<SupportCategory, string>> = {
  feedback: 'Feedback',
  billing: 'Billing',
  help: 'Help',
  abuse: 'Report Abuse',
};

export const SUPPORT_MESSAGE_MIN = 10;
export const SUPPORT_MESSAGE_MAX = 4000;
/** Messages one person may send in a day. */
export const SUPPORT_PER_DAY = 5;
/** How long a message is kept: the Privacy Policy says up to 2 years. */
export const SUPPORT_KEEP_DAYS = 730;

/** GSI on `Support`: `userId` + `createdAt` (keys only), for counting a person's messages in a day. */
export const SUPPORT_BY_USER_INDEX = 'byUser';

/** An item in the `Support` table: one message, with who sent it and where to reply. */
export interface SupportTicket {
  /** A ULID: sorts by when it was sent. */
  ticketId: string;
  userId: string;
  category: SupportCategory;
  /** The server it's about, if they picked one. */
  serverId?: string;
  message: string;
  createdAt: string; // ISO 8601 UTC
  /** Where to reply, and who to, as their account said when they wrote. */
  email?: string;
  name?: string;
  /** When DynamoDB's TTL removes it (epoch seconds): SUPPORT_KEEP_DAYS after it was sent. */
  expiresAtEpoch: number;
}
